const state = {
  hasAccount: false,
};

const mutations = {
  setHasAccount (state, data) {
    state.hasAccount = data;
  },
};

export const oneTimeUser = {
  namespaced: true,
  state,
  mutations,
};
